/// <reference path="../../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class GotoWorkflowBlock extends SingleOutputWorkflowBlock {

        private radius: number;
        private xPadding: number;
        private yPadding: number;
        private attributes: any;
        private feedbackArrow: Snap.Element;
        private toggleEnabledFeedbackArrow: Snap.Element;
        public standardLabel: Snap.Element;

        constructor(id: string, label: string) {
            super(id, Wars.Domain.Model.Codes.Enums.BlockType.Goto, label);

            this.svgScale = 0.75;
            this.svgToolbarScale = 0.4;
            this.svgWidth = 100;
            this.svgHeight = 100;

            this.svgUrl = "./Content/Images/WorkflowShapes/Goto.svg";
            this.svgAttributes = { id: this.id, "data-class": "workflowBlock", "data-id": "goto" };
        }

        public hideFeedbackArrow(): void {
            if (this.feedbackArrow) {
                this.feedbackArrow.stop();
                this.feedbackArrow.attr({ opacity: '0' });
            }
        }

        public showFeedbackArrow(): void {
            if (this.feedbackArrow) {
                this.feedbackArrow.animate({ opacity: '1' }, 300);
            }
        }

        public hoverStart(): void {
            this.showOptions();
            this.showFeedbackArrow();
        }

        public hoverEnd(): void {
            this.hideOptions();
            this.hideFeedbackArrow();
        }

        public entireWorkflowDrawComplete() {
            this.toggleEnabledFeedbackArrow = this.drawingInstance.drawFeedbackArrow(this, this.toBlock, true);
            super.entireWorkflowDrawComplete();
        }

        public entireWorkflowDrawComplete2() {
            this.feedbackArrow = this.drawingInstance.drawFeedbackArrow(this, this.toBlock, false);
            this.hideFeedbackArrow();
            super.entireWorkflowDrawComplete2();
        }
    }
}